import { createContext } from 'react';
import { Theme } from '@mui/material/styles';

export const AdminThemeContext = createContext<Theme | null>(null);
